import Service, { service } from '@ember/service';

export const CLIENT_PORTAL_PAGES = {
  APPOINTMENTS: 'appointments_page',
  BILLING: 'billing_payments',
  DOCUMENTS: 'documents_page',
};

export const DOCUMENT_TYPES = {
  CONSENT_DOCUMENT: 'consent_document',
  CREDIT_CARD_FORM: 'credit_card_form',
  DEMOGRAPHICS_FORM: 'demographics_form',
  QUESTIONNAIRE: 'questionnaire',
};

export default class ClientPortalTrackingService extends Service {
  @service analytics;

  #trackError(errorMessage, clientPortalPage, documentType) {
    /* eslint-disable camelcase */
    this.analytics.selectiveTrack('Error in Client Portal Displayed', {
      error_message: errorMessage,
      client_portal_page: clientPortalPage,
      document_type: documentType ?? null,
    });
    /* eslint-enable camelcase */
  }

  trackErrorInClientPortal(errorMessage, options = {}) {
    let { clientPortalPage, documentType } = options;
    this.#trackError(errorMessage, clientPortalPage, documentType);
  }

  trackErrorOnDocumentsPage(errorMessage, options = {}) {
    let { documentType } = options;
    this.#trackError(errorMessage, CLIENT_PORTAL_PAGES.DOCUMENTS, documentType);
  }

  trackErrorOnBillingPage(errorMessage) {
    this.#trackError(errorMessage, CLIENT_PORTAL_PAGES.BILLING, null);
  }

  trackErrorOnAppointmentsPage(errorMessage) {
    this.#trackError(errorMessage, CLIENT_PORTAL_PAGES.APPOINTMENTS, null);
  }
}
